<template>
  <router-view></router-view>
</template>

<script>

export default {
  name: 'page-template-component',
}
</script>

<style lang="scss">
</style>
